import { useEffect, useState } from "react";
import { getByRegistroReferencia, putOne } from "../../../../database/dbRegistroGeneral";
import { Avatar, Box, Button, Container, createTheme, CssBaseline, Divider, Grid, Paper, TextField, ThemeProvider, Typography } from "@mui/material";
import { FileUploadCustom } from "../../../modules/ui/FileUploadCustom";
import { CustomDialog } from "../../../modules/dialogs/CustomDialog";
import { logObject } from "../../../../utils/validations";
import Swal from "sweetalert2";
import { isBefore } from "date-fns";

export const Sina2025TrabajosEdicion = () => {

    const queryParameters = new URLSearchParams(window.location.search)
    const ref = queryParameters.get("id")


    const [record, setRecord] = useState({});
    const [works, setWorks] = useState([]);
    
    const [isDataLoaded, setisDataLoaded] = useState(false);

    const [uploadingFile, setUploadingFile] = useState(false);



    const updateWork = (id, field, value) => {

        const workIndex = works.findIndex(w => w.id === id);
        const worksTmp = JSON.parse(JSON.stringify(works));
        worksTmp[workIndex][field] = value;

        setWorks(worksTmp);
    }


    const handleMediaFilesURLChange = ({ target }) => {
        const { name, value } = target;
        console.log({ name, value });

        updateWork(name, 'mediaFilesURL', value);
    }


    const handleGuardarCambios = async() => {
        console.log({record});
        logObject(works);
        // Generamos la copia de infoAdicional;
        const infoAdicionalTmp = JSON.parse(JSON.stringify(record.infoAdicional));
        // Actualizamos los trabajos con el state actual
        infoAdicionalTmp.trabajos = works;
        
        // Contruimos el objeto para actualizar el registro
        const recordToSave = { ...record, infoAdicional: JSON.stringify(infoAdicionalTmp) };
        console.log({recordToSave});
        
        // Se actualiza el registro
        const { exito } = await putOne(record.id, recordToSave);
        
        if (exito) {
            Swal.fire({
                title: '¡Registro actualizado!',
                text: 'Puede cerrar la ventana o continuar modificando.',
                showConfirmButton: false,
                timer: 3000
            })
        } else {
            Swal.fire({
                title: '¡Error al actualizar!',
                text: 'Presione -Ok-, tome una captura de pantalla y notifique al desarrollador.',
                icon: 'error',
            })
        }
    }
    
    
    //* Se recupera y formatea la data
    useEffect(async() => {

        const { data } = await getByRegistroReferencia(ref);
        const recordTmp = data[0];

        const infoAdicional = JSON.parse(recordTmp.infoAdicional);
        setWorks(infoAdicional.trabajos);

        const recordToShow = { ...recordTmp, infoAdicional: infoAdicional };
        console.log(recordToShow)
        setRecord(recordToShow);

        setisDataLoaded(true);
    }, [ ref ])


    useEffect(() => {
        const todayDate = new Date();
        const limitDate = new Date(2025, 11, 13);
        console.log({limitDate});
        const onTime = isBefore(todayDate, limitDate)
        console.log({onTime});

        if (!onTime) {
            Swal.fire({
                title: "¡Gracias! / Thank you!",
                text: 'La fecha límite de actualización ha sido superada / Update date expired.',
                icon: 'info',
                showConfirmButton: false,
                allowEscapeKey: false,
                allowOutsideClick: false,
            })
        }
    }, [ ])
    

    return (
        <ThemeProvider theme={createTheme()}>
        <Container component="main">
        <CssBaseline />
        <Box m={ 2 } display='flex' flexDirection='row' alignItems='center'>
            <Avatar src='https://aena.mx/images/nicepage-images/80f8a68a08b4341bcc455d466709dc31.png' sx={{ width: 100, height: 'auto', px: 2 }} />
            <Box>
                <Typography fontSize={ 20 } fontWeight={ 900 }>Simposio Internacional en Nutrición Acuícola</Typography>
                <Typography fontSize={ 20 }>Gestión de trabajos / Work management</Typography>
            </Box>
        </Box>

        <CustomDialog title='Por favor espere / Please wait' show={ !isDataLoaded } />
        <CustomDialog title='Cargando archivo...' show={ uploadingFile } />

        {
            isDataLoaded &&
            <Paper elevation={ 4 } sx={{ m: 2, p: 2 }}>
                <Grid container spacing={ 2 }>
                    <Grid item xs={ 6 }>
                        <Typography fontSize={ 24 } fontWeight={ 900 }>
                            { `${ record.partApellidoPaterno } ${ record.partApellidoMaterno } ${ record.partNombres }` }
                        </Typography>
                        <Typography color='blue'>{ record.partCorreo }</Typography>
                        <Typography>{ ref }</Typography>
                    </Grid>
                    <Grid item xs={ 6 }>
                        <Typography>Modalidad / Modality: <strong>{ record.infoAdicional.modalidad }</strong></Typography>
                        <Typography>Ocupación/puesto / Position: <strong>{ record.tipoRegistro }</strong></Typography>
                        {
                            record.tipoRegistroDocURL !== ''
                            ? <a href={ record.tipoRegistroDocURL } target='_blank'>Consultar documento / View document</a>
                            : <></>
                        }
                    </Grid>

                    <Grid item xs={ 12 }><Divider sx={{ my: 1 }}/></Grid>

                    <Grid item xs={ 12 }>
                        <Typography>Total de trabajos / Number of works: <strong>{ works.length }</strong></Typography>
                        {
                            works.map(work =>
                                <Box key={ work.id } my={ 1 } p={ 1 } sx={{ border: '1px solid lightblue' }}>

                                    <Box display='flex' flexDirection='row' justifyContent='space-between' py={ 1 } alignItems='center'>

                                        <Box>
                                            <Typography fontStyle='italic' fontSize={ 16 }>{ work.title }</Typography>
                                            <Typography fontSize={ 14 }>
                                                Nombre del archivo: <strong>
                                                    { work.url.slice( work.url.lastIndexOf('/') + 1) }
                                                </strong>
                                            </Typography>

                                        </Box>
                                        <Typography fontWeight={ 900 } fontSize={ 16 } color={ work.status === 'devuelto' ? 'red' : 'blue' }>
                                            { work.status }
                                        </Typography>
                                    </Box>

                                    <Box display={ work.status === 'devuelto' ? 'flex' : 'none' } sx={{ border: '1px solid pink', borderRadius: 2 }} p={ 2 } mt={ 1 } mb={ 2 }>
                                        <TextField
                                            fullWidth
                                            id={ work.id }
                                            label={ 'Comentarios a atender' }
                                            maxRows={ 8 }
                                            // minRows={ 2 }
                                            multiline
                                            name={ work.id }
                                            size='small'
                                            type='text'
                                            // onChange={ handleWorkCommentsChanged }
                                            variant={ 'standard' }
                                            value={ work.statusComments }
                                        />
                                    </Box>

                                    <Typography fontSize={ 14 } color='blue'>
                                        Reemplazar archivo en el sistema / Replace file in the system
                                    </Typography>
                                    <Typography fontSize={ 14 }>
                                        Al seleccionarlo será sustituido automaticamente / Selecting the file it will be automatically replaced
                                    </Typography>

                                    <FileUploadCustom 
                                        helperText='Agregar resumen, archivo en formato DOCX / Add resume, in DOCX format'
                                        parentCallback={ (e) => console.log(e) }
                                        parentWaitingCallback={ (val) => setUploadingFile(val) }
                                        saveFileAs= { `${ work.url.slice( work.url.lastIndexOf('/') + 1, work.url.lastIndexOf('.')) }` }
                                        validTypes ={ ['docx'] }
                                        variant='standard'
                                    />

                                    <Box my={ 1 }>
                                        <Typography fontSize={ 14 } color='blue'>
                                            Indicar ubicación de los archivos / Indicate files location
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            id="mediaFilesURL"
                                            helperText='URL de la carpeta / Folder URL'
                                            label="Google Drive"
                                            name={ work.id }
                                            size="small"
                                            onChange={ handleMediaFilesURLChange }
                                            variant='filled'
                                            value={ work.mediaFilesURL }
                                        />
                                    </Box>
                                        
                                </Box>
                            )
                        }
                        
                        <Box display='flex' flexDirection='row' justifyContent='flex-end'>
                            <Button 
                                variant='contained' 
                                onClick={ handleGuardarCambios }
                                size='small'
                                color='warning'
                            >
                                Guardar cambios / Save changes
                            </Button>
                        </Box>

                        {/* <Box display='flex' flexDirection='row' justifyContent='space-between'>
                            
                            <Box display='flex' flexDirection='column'>
                                <Typography color='red' fontWeight={ 900 }>IMPORTANTE / IMPORTANT:</Typography>
                                <Typography>
                                    Al cargar los archivos, estos seran sustituidos automaticamente en el sistema / Uploading the files, these will be automatically replaced
                                </Typography>
                            </Box>
                        </Box> */}
                    </Grid>


                </Grid>
            </Paper>
        }

        </Container>
        </ThemeProvider>
    )
}
